import { Button, Popconfirm } from 'antd'
import { Guard } from 'src/features/session/guard'
import { submitModerationTask } from 'src/pages/worldCup2026/tasks/model'

type Props = {
  id: number
}
export const ApproveButton = ({ id }: Props) => {
  return (
    <Guard permission="world_cup_2026_task_update">
      <Popconfirm
        title="Confirm approve task"
        onConfirm={() =>
          submitModerationTask({
            id: String(id),
            status: 'accepted',
            declineReason: '',
          })
        }
      >
        <Button color="green" variant="solid">
          Approve
        </Button>
      </Popconfirm>
    </Guard>
  )
}
